import { Delete, Get, getAPIUrl, Post } from "../../../services/apiMethod";

export const ContactUsEndpoint = {
  getContactData: `/admin/get-contact-us`,
  deleteContactData: `/admin/delete-contact-us`,
};
export const getContactData = (param = "") => {
  const url = getAPIUrl(ContactUsEndpoint.getContactData, param);
  return Get(url);
};
export const deleteContactData = (data, param = "") => {
  const url = getAPIUrl(ContactUsEndpoint.deleteContactData, param);
  return Post(url, data, true);
};
